const unreadMaxCount = 99
export const UnreadBadge: React.FC<{ count: number | undefined }> = (props) => {
  if (props.count == null || props.count === 0) return <></>
  return (
    <div
      className="flex flex-shrink-0 items-center justify-center text-[10px] leading-[10px] rounded-full bg-secondary text-white w-[22px] h-[22px]"
      // 数字と + で違うフォントが選ばれると不自然なので明示的に Noto Sans JP を指定する
      style={{ fontFamily: 'Noto Sans JP' }}
    >
      {props.count >= unreadMaxCount ? `${unreadMaxCount}+` : props.count}
    </div>
  )
}
